import { render } from "./supportCard.vue?vue&type=template&id=e380c24e&scoped=true&ts=true"
import script from "./supportCard.vue?vue&type=script&lang=ts&config=true"
export * from "./supportCard.vue?vue&type=script&lang=ts&config=true"

import "./supportCard.vue?vue&type=style&index=0&id=e380c24e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e380c24e"]])

export default __exports__